/**
 * Standard variable names used in expression evaluation contexts.
 * These variables are set in VariableScope instances when evaluating expressions
 * to provide data to expression evaluators.
 */
export class VariableNames {
    /**
     * Current item in a collection iteration (e.g., RepeatContainer, collection operations).
     * Type varies based on collection element type.
     */
    static readonly Item = "$item";

    /**
     * Event data passed to event handler expressions (e.g., OnClick, OnChange).
     * Type varies based on the event source.
     */
    static readonly Event = "$event";

    /**
     * Output from an operation or function call.
     * Type varies based on the operation.
     */
    static readonly Output = "$output";

    /**
     * View-scoped context data accessible throughout a view.
     * Type: Record<string, any>
     */
    static readonly Context = "$ctx";

    /**
     * Session-scoped data shared across views in the same session.
     * Type: Record<string, any>
     */
    static readonly Session = "$session";

    /**
     * Current user information.
     * Type: User model
     */
    static readonly User = "$user";

    /**
     * Source data from a domain service operation response.
     * Type varies based on the operation.
     */
    static readonly Source = "$source";

    /**
     * View model instance for the current view.
     * Type: ViewModel
     */
    static readonly View = "$view";

    /**
     * Input parameters passed to a view or component.
     * Type: Record<string, any>
     */
    static readonly Input = "$input";

    /**
     * Current search text in a GlobalSearch component.
     * Type: string
     */
    static readonly SearchText = "$searchText";
}
